import React from 'react';
import { SectionCTA } from '../SectionCTA';
import { EcgLine } from '../EcgLine';
const stats = [{
  value: '6',
  label: 'Comprehensive ECG Learning Volumes'
}, {
  value: '5',
  label: 'Specialized Professional Study Bonuses'
}, {
  value: '1',
  label: 'Organized Educational Interpretation Framework'
}, {
  value: '+',
  label: 'Rhythm Charts, Worksheets, Reference Tables & Practice Cases'
}];
export function Problem() {
  return <section className="bg-white px-5 py-16 md:py-24" aria-labelledby="problem-title" data-id="element-246" data-mp="2hrse5auokjou">
      <div className="mx-auto max-w-3xl" data-id="element-247" data-mp="2cqcvtqjw0ra5">
        <p className="text-center font-display text-xs font-extrabold uppercase tracking-[0.14em] text-pulse sm:text-sm" data-id="element-248" data-mp="28pj5kqiz30e3">
          For nursing students, registered nurses & critical care professionals
        </p>
        <h2 id="problem-title" className="mt-3 text-center font-display text-3xl font-black leading-tight text-navy-900 sm:text-5xl text-balance" data-id="element-249" data-mp="6xw9iak84far">
          ECG Interpretation Doesn’t Have to Feel Like Memorizing an Endless Collection of Heart Rhythms
        </h2>

        <div className="mt-10 space-y-5 text-lg leading-relaxed text-ink" data-id="element-250" data-mp="199wtg8bhlkkb">
          <p data-id="element-251" data-mp="19829oxbybyht">Let me ask you something.</p>
          <p className="rounded-2xl bg-pulse-50 px-5 py-4 font-display text-xl font-extrabold leading-snug text-navy-900 sm:text-2xl" data-id="element-252" data-mp="vb5hosk3kazc">
            Have you ever looked at an ECG tracing and wondered where to begin?
          </p>
          <p data-id="element-253" data-mp="1nzkvjbrhsn93">You recognize the P wave, QRS complex, and T wave.</p>
          <p data-id="element-254" data-mp="1s1662qgk0pg4">You know that heart rate, rhythm regularity, and intervals matter.</p>
          <p data-id="element-255" data-mp="1e9hr8fex7mvg">
            But when several findings appear together,{' '}
            <strong className="font-bold" data-id="element-256" data-mp="1e75ag5kwfijz">organizing everything into a clear interpretation becomes much more challenging.</strong>
          </p>

          <EcgLine className="my-8 h-10 w-full opacity-60" beats={5} data-id="element-257" data-mp="26xnbz25z5bva" />

          <p data-id="element-258" data-mp="2bond6jm4mg3l">Maybe you’ve spent hours reviewing cardiac rhythm charts.</p>
          <p data-id="element-259" data-mp="2bqq91k9yn3g8">Maybe you understand a concept while reading it, only to struggle when you encounter a different tracing.</p>
          <p data-id="element-260" data-mp="2glj6jzz096d4">
            Or perhaps you want a more organized way to study 12-lead ECGs without constantly switching between
            textbooks, lecture notes, and online resources.
          </p>
          <p className="font-bold text-navy-800" data-id="element-261" data-mp="26nd7rr8hwgch">That’s exactly the learning challenge this collection is designed to address.</p>
          <p data-id="element-262" data-mp="22m049nsvkp8q">
            The ECG Interpretation Blueprint™ brings essential ECG concepts together into one structured educational
            pathway. Instead of jumping between disconnected explanations, you’ll have six complementary volumes that
            guide you through the fundamentals, rhythm recognition, 12-lead concepts, and simulated interpretation
            exercises.
          </p>
        </div>
      </div>

      <div className="mx-auto mt-14 max-w-5xl rounded-3xl bg-navy-950 p-6 text-white sm:p-10" data-id="element-263" data-mp="1ix963pevaqo4">
        <h3 className="text-center font-display text-lg font-extrabold uppercase tracking-wide text-gold" data-id="element-264" data-mp="1ewp9cmy7hp2i">
          Your educational collection includes
        </h3>
        <dl className="mt-8 grid grid-cols-2 gap-x-6 gap-y-8 lg:grid-cols-4" data-id="element-265" data-mp="3ukcnkxvlffec">
          {stats.map(stat => <div key={stat.label} className="text-center" data-id="element-266" data-mp="3fur8bhmyosd">
              <dt className="sr-only" data-id="element-267" data-mp="8dw58i07fxwz">{stat.label}</dt>
              <dd className="font-display text-6xl font-black leading-none text-pulse sm:text-7xl" data-id="element-268" data-mp="8de354qv2ph5">{stat.value}</dd>
              <dd className="mt-2 text-sm font-semibold leading-snug text-white/85 sm:text-base" data-id="element-269" data-mp="36xcsu16tezkc">{stat.label}</dd>
            </div>)}
        </dl>
        <p className="mt-8 text-center text-xs text-white/55" data-id="element-270" data-mp="3gtfuz71o2y7a">
          These figures describe the collection’s contents, not independently verified educational outcomes.
        </p>
      </div>

      <SectionCTA label="Start my structured ECG learning system" data-id="element-271" data-mp="2o5tva9vk8dpp" />
    </section>;
}